export default __webpack_public_path__ + "static/media/witnesses-witnesses.8929c449.jpg";